import DietaryIcons from '../../../components/DietaryIcons';
import checkSelected from '../../../img/icons/checkSelected-new.svg';

const UpsellCard = ({ product, isSelected, onSelect, swapPriceDifference, isTabletScreen }) => {
  const swapText = swapPriceDifference !== undefined
    ? swapPriceDifference > 0
      ? `+${swapPriceDifference.toFixed(2)} to swap`
      : swapPriceDifference < 0
        ? `-${Math.abs(swapPriceDifference).toFixed(2)} to swap`
        : 'No extra cost to swap'
    : null;

  return (
    <button
      className={`upsell-card${isSelected ? ' upsell-card--selected' : ''}`}
      onClick={onSelect}
      type="button"
      aria-pressed={isSelected}
    >
      <div className="upsell-card__image-wrapper">
        {product.imageUrl && (
          <img
            className="upsell-card__image"
            src={product.imageUrl}
            alt={product.name}
            onError={(e) => {
              if (product.fallbackImageUrl && e.currentTarget.src !== product.fallbackImageUrl)
                e.currentTarget.src = product.fallbackImageUrl;
            }}
          />
        )}
        {isSelected && (
          <span className="upsell-card__tick-wrapper">
            <img className="upsell-card__tick" src={checkSelected} alt="Selected" />
          </span>
        )}
      </div>
      <div className="upsell-card__info">
        <p className="upsell-card__name">{product.name}</p>
        <div className="upsell-card__price-row">
          <span className="upsell-card__price">{product.displayPrice?.toFixed(2)}</span>
          <DietaryIcons icons={product.dietPreferences} iconSize={isTabletScreen ? 16 : 24} style={{marginTop: 0, gap: '8px'}} />
        </div>
        {swapText && (
          <p className="upsell-card__swap-text">{swapText}</p>
        )}
      </div>
    </button>
  );
};

export default UpsellCard;
